import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const DomainQuerySupport = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a192f] via-[#112240] to-[#0a192f]">
      <Helmet>
        <title>DomainQuery - Support</title>
      </Helmet>

      {/* Header */}
      <div className='w-full h=[80px] flex justify-between items-center px-4 py-2 text-gray-300'>
        <div>
          <Link to="/" className='text-4xl font-bold md:flex hover:text-blue-400 transition duration-300'>
            Ahnaf Mahmud
          </Link>
        </div>
      </div>
      
      {/* Main Content Section */}
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-white mb-8">DomainQuery Support</h1>
          
          <div className="space-y-6 text-gray-300">
            <p>
              For any support queries, please email <a href="mailto:mail@ahnafmahmud.com" className="text-blue-400 hover:text-blue-300">mail@ahnafmahmud.com</a>
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-16 pt-8 border-t border-gray-700">
          <p className="text-gray-400">
            © 2025 Ahnaf Mahmud
          </p>
        </div>
      </div>
    </div>
  );
};

export default DomainQuerySupport;
